import Commonheader from '@/components/Commonheader.vue'
import Commonheader2 from '@/components/Commonheader2.vue'
import leftMenu from '@/components/leftMenu.vue'
import Commonfooter from '@/components/Commonfooter.vue'
// 新建tabs标签页组件
import Breadtabsheader from "@/components/breadtabsheader.vue"
import breadcrumb from "@/components/breadcrumb.vue"
//分页组件
import pagination from "@/components/basic/pagination.vue"
import paginationmin from "@/components/basic/paginationmin.vue"
import paginationminNosize from "@/components/basic/paginationminNosize.vue"
import paginationmincopy from "@/components/basic/paginationmincopy.vue"

//新建需求组件
import demandadd from "@/components/popPup/demandAdd.vue"

//新建项目组件
import projectadd from "@/components/popPup/projectAdd.vue"

//新建订单组件
import dingdAdd from "@/components/popPup/dingdAdd.vue"

// 漏斗弹出窗组件
import loud from "@/components/dialog/loud.vue"
import loudnew from "@/components/dialog/loudnew.vue"
// 线索弹出窗组件
import clue from "@/components/dialog/clue.vue"

//新建合同组件
import contractAdd from "@/components/popPup/contractAdd.vue"

//运维人员组件
import operation from "@/components/popPup/operation.vue"

import ordernxsp from "./components/order/orderNxshenpi"
import orderwxsp from './components/order/orderWxshenpi'
import ordershsp from "./components/order/orderShshenpi"
import secondOrdernxsp from "./components/order/secondLevelOrderNxshenpi"
import secondFjnxsp from "./components/order/secondLevelFjNxshenpi"

//下拉选择框组件
import brselect from "@/components/basic/selects.vue"
import desselect from "@/components/basic/desselects.vue"
import mdmselect from "@/components/basic/mdmselect.vue"
import brselectlazy from "@/components/basic/lazyselects.vue"

import dict from "@/components/basic/dictname.vue"
import des from "@/components/basic/dictdes.vue"
import brupload from "@/components/uploaddown/uploaddown.vue"
import bruploadchi from "@/components/uploaddown/uploaddownchi.vue"
import bruploadTX from "@/components/uploaddown/uploaddownTX.vue"
// 省市区选择
import areaSelect from "@/components/areaSelect.vue"
import areaSelectNotDetails from "@/components/areaSelectNotDetails.vue"
import viewhistory from "@/components/flow/taskhistory.vue"
import viewscoretable from "@/components/score/scoreTable.vue"
import viewscoreShenPi from "@/components/score/scoreShenPi.vue"

import wuliaomiaoshuSelect from "@/views/loud/xiangmu/wuliaomiaoshuSelect.vue"
import showBom from "@/components/basic/showBom.vue"

//tree组件
import vtree from 'vue-jstree'


import echarts from 'echarts'
import 'echarts/map/js/china'
import msg from '@/utils/msg'
import util from '@/utils/util'
import _ from 'loadsh'
import big from 'big.js'
import store from './store'


import { mapState } from 'vuex'
import uploadDown from '@/utils/updownfile'
export default {
    install(Vue){

        //全局的组件
        Vue.component("brselect", brselect);
        Vue.component("desselect", desselect);
        Vue.component("mdmselect", mdmselect);
        Vue.component("brselectlazy", brselectlazy);
        Vue.component("pagination", pagination);
        Vue.component("paginationmin", paginationmin);
        Vue.component("paginationminNosize", paginationminNosize);
        Vue.component("paginationmincopy", paginationmincopy);
        Vue.component("breadcrumb", breadcrumb);
        Vue.component("Breadtabsheader", Breadtabsheader);
        Vue.component("loud", loud);
        Vue.component("loudnew", loudnew);
        Vue.component("clue", clue);
        Vue.component("dictname", dict);
        Vue.component("dictdes", des);
        Vue.component("brupload", brupload);
        Vue.component("bruploadchi", bruploadchi);
        Vue.component("bruploadTX", bruploadTX);
        Vue.component("vtree", vtree);
        Vue.component("viewhistory", viewhistory);
        Vue.component("viewscoretable", viewscoretable);
        Vue.component("viewscoreShenPi", viewscoreShenPi);
        Vue.component(Commonheader.name, Commonheader);
        Vue.component(Commonheader2.name, Commonheader2);
        Vue.component(leftMenu.name, leftMenu);
		Vue.component(Commonfooter.name, Commonfooter);
		Vue.component("areaSelect", areaSelect);
        Vue.component("areaSelectNotDetails", areaSelectNotDetails);
        Vue.component("wuliaomiaoshuSelect", wuliaomiaoshuSelect);
        Vue.component("demandadd",demandadd);
        Vue.component("projectadd",projectadd);
        Vue.component("dingdadd",dingdAdd);
        Vue.component("contractadd",contractAdd);
		Vue.component("operation",operation);

        Vue.component("ordernxsp",ordernxsp);
        Vue.component("orderwxsp",orderwxsp);
        Vue.component("ordershsp",ordershsp);
        Vue.component("showBom", showBom);
        Vue.component("secondOrdernxsp",secondOrdernxsp);
        Vue.component("secondFjnxsp",secondFjnxsp);


        Vue.filter('dictname', function (value,cate,muti) {
            if(!cate || value==null || String(value) == '' ){
                return "";
            }
            var v = [];
            var vcode = _.split(value,",")
            _.forEach(vcode,(o)=>{
                v.push(store.getters.dictname(cate,o))
            })
            return v.join(",");
        })

        Vue.filter('dictdes', function (value,cate) {
            if(!cate || value==null || String(value) == '' ){
                return "";
            }
            return store.getters.dictdes(cate,value)
        })
        Vue.filter('dictrefid', function (value,cate) {
            if(!cate || value==null || String(value) == '' ){
                return "";
            }
            return store.getters.dictrefid(cate,value)
        })


        // 2. 添加全局资源
        Vue.directive('auth', {
            bind (el, binding, vnode, oldVnode) {
                if(!_.includes(vnode.context.$store.getters.rescodelist,binding.value)){
                    el.style.display = 'none';
                }
            }
        })

        Vue.directive('down', {
            // 初始化指令
            bind(el, binding, vnode) {
                // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
                el.addEventListener('click', function () {
                    if(binding.arg){
                        uploadDown.downByrefidtype({refid:binding.value,reftype:binding.arg})
                    }else{
                        uploadDown.downByid(binding.value)
                    }
                });
            }
        })

        // 3. 注入组件选项
        Vue.mixin({
            created: function () {
                // 逻辑...
            },
            computed: mapState({
                _user:state => state.user,
            })
        })
        // 4. 添加实例方法
        Vue.prototype.$getDictName = function (c,v) {
            return this.$store.getters.dictname(c,v)
        }

        // 4. 添加实例方法
        Vue.prototype.$getDictdes = function (c,v) {
            return this.$store.getters.dictdes(c,v)
        }

        //使用echarts
        Vue.prototype.$echarts = echarts
        Vue.prototype.$msg = msg
        Vue.prototype.$util = util
        Vue.prototype._ = _
        Vue.prototype.big = big
        Vue.prototype.$baseurl = process.env.VUE_APP_AJAXURL
    },
}
